import * as React from 'react'

import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'

import kugelTiefSVG from '../../assets/kugel-tiefe-lagen.svg'

import styled from 'styled-components'
import kugelDeckelSVG from '../../assets/kugel-deckel.svg'
import SnowAnimator from 'components/Snow/SnowAnimator'
import './styles.scss'

const SnowAnimationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  /* background-color: green; */
  mask-image: url(${({ maskImage }) => maskImage});
  mask-repeat: no-repeat;
  mask-size: contain;
`
const SnowAnimation = styled.div``


export default class TiefeLagen extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (

      <TextWidth>
        <div className='content' style={{ textAlign: 'center' }}>
          <div className='ui text container category first'>
            <div className='content-wrapper'>
              <div className='category content tief'>
                <span className='category title tief'>{this.props.languageContent.tiefeLagen.title}</span>
                <span className='category hoehe tief'>{this.props.languageContent.tiefeLagen.altitude}</span>
              </div>

              <div className='coverContent' id='coverDetail'>
                <div className='coverTextWrapper tief'>
                  <div className='coverProzent tief'>{this.props.languageContent.tiefeLagen.percent}</div>
                  <div className='coverText tief'>{this.props.languageContent.tiefeLagen.unit}</div>
                  <div className='triangle tief'></div>
                </div>
                <div className='animation-container'>
                  <SnowAnimationContainer maskImage={kugelDeckelSVG}>
                    <SnowAnimator snowflakeCount={50} />
                  </SnowAnimationContainer>
                  <img src={kugelTiefSVG} alt='Schneekugel' />
                </div>
              </div>

              <div className='list tief'>
                <ul>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.tiefeLagen.metrics[0]}}></li>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.tiefeLagen.metrics[1]}}></li>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.tiefeLagen.metrics[2]}}></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </TextWidth>
    )
  }
}
